/**
 * @author: sim
 * @since: Mon Dec 19 2016 15:16:20 GMT+0530 (IST)
 * @file: urls.js
 *
 * @copyright: KNOLSKAPE Solutions Pvt Ltd
 **/

/**
 *
 * Exports urls for API
 *
 **/

export const urlConsts = {
    API_INIT: process.env.REACT_APP_BASE_URL + "storyline/1",
    POST_API: process.env.REACT_APP_BASE_URL + "mail-response",
    MAIL_READ: process.env.REACT_APP_BASE_URL + "mail-read",
    MAIL_STARRED: process.env.REACT_APP_BASE_URL + "mail-starred",
    MAIL_TIME_OUT: process.env.REACT_APP_BASE_URL + "mail-timeout",
    SURVEY_SINGLE_ANSWERS:
        process.env.REACT_APP_BASE_URL + "mail-survey-single",
    SURVEY_POST_API: process.env.REACT_APP_BASE_URL + "mail-survey",
    SEND_TO_VOICE_MAIL: process.env.REACT_APP_BASE_URL + "send-to-voice-mail",
    TERMINATE_CALL: process.env.REACT_APP_BASE_URL + "call-terminate",
    CALL_STARTED: process.env.REACT_APP_BASE_URL + "call-started",
    TUTORIAL_STATUS: process.env.REACT_APP_BASE_URL + "tutorial-status",
    TUTORIAL_COMPLETED: process.env.REACT_APP_BASE_URL + "tutorial-completed",
    GAME_COMPLETED: process.env.REACT_APP_BASE_URL + "game-completed",
    USER_REPORT: process.env.REACT_APP_BASE_URL + "user-report",
    SET_SURVEY_SEQUENCE:
        process.env.REACT_APP_BASE_URL + "save-user-survey-sequence",
    LOGOUT_URL: process.env.REACT_APP_BASE_URL + "logout",
    RETURN_URL: process.env.REACT_APP_BASE_URL + "return-to-lms",
    GET_FIREBASE_TOKEN: process.env.REACT_APP_BASE_URL + "get-firebase-token"
    // }
};

export default urlConsts;



// WEBPACK FOOTER //
// /src/constants/urls.js